import { SVG_PATHS } from "@/shared/constants/assets-path";
import Button from "@/shared/ui/buttons/base-button";
import PopUpModal from "@/shared/ui/modal/pop-up";

interface AlertModalProps {
  isOpen: boolean;
  onClose?: () => void;
  onConfirm?: () => void;
  title: string;
  confirmText?: string;
  cancelText?: string;
  closeOnOverlayClick?: boolean;
  children: React.ReactNode;
}

export default function AlertModal({
  isOpen,
  onClose,
  onConfirm,
  title,
  confirmText = onConfirm ? "확인" : undefined,
  cancelText = onClose ? "취소" : undefined,
  closeOnOverlayClick = false,
  children,
}: AlertModalProps) {
  return (
    <PopUpModal
      isOpen={isOpen}
      onClose={onClose}
      title={
        <div className="flex flex-col items-center gap-3">
          <div className="flex h-11 w-11 items-center justify-center rounded-full bg-secondary-light03">
            <img
              src={SVG_PATHS.ALERT}
              alt="경고 아이콘"
              width={30}
              height={30}
            />
          </div>
          <p className="font-bold text-primary-dark02">{title}</p>
        </div>
      }
      className="text-center"
      closeOnOverlayClick={closeOnOverlayClick}
      footer={
        <div className="flex flex-1 gap-2">
          {cancelText && (
            <Button
              className="w-full bg-primary-dark02 text-white"
              onClick={onClose}
            >
              {cancelText}
            </Button>
          )}
          {confirmText && (
            <Button variant="secondary" className="w-full" onClick={onConfirm}>
              {confirmText}
            </Button>
          )}
        </div>
      }
    >
      {children}
    </PopUpModal>
  );
}